import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'

import listaNcm from './store/modules/listaNcm'
import modalFuncionalidades from './store/modules/modalFuncionalidades'
import auth from './store/modules/auth'
import loading from './store/modules/loading'
import loadings from './store/modules/loadings'
import login from './store/modules/login'
import usuario from './store/modules/usuario'
import avisos from './store/modules/avisos'
import tributos from './store/modules/tributos'
import tributosST from './store/modules/tributosST'
import resultado from './store/modules/resultado'
import pesquisaNcm from './store/modules/pesquisaNcm'
import empresa from './store/modules/empresa'
import cenario from './store/modules/cenario'
import forceUpdate from './store/modules/forceUpdate'
import modal from './store/modules/modal'
import alertas from './store/modules/alertas'
import observacoes from './store/modules/observacoes'
import complementoIcms from './store/modules/complementoIcms'
import reRender from './store/modules/reRender'
import tributosSelecionados from './store/modules/tributosSelecionados'
import form from './store/modules/form'
import logResultados from './store/modules/logResultados'

Vue.use(Vuex)

export default new Vuex.Store({
	plugins: [createPersistedState({
		storage: window.sessionStorage,
	})],
	state: {

	},
	mutations: {

	},
	actions: {

	},
	modules: {
		listaNcm,
		modalFuncionalidades,
		auth,
		loading,
		loadings,
		login,
		usuario,
		avisos,
		tributos,
		tributosST,
		resultado,
		pesquisaNcm,
		empresa,
		cenario,
		forceUpdate,
		modal,
		alertas,
		observacoes,
		complementoIcms,
		reRender,
		tributosSelecionados,
		form,
    logResultados
	}
})
